import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  table: {
    borderCollapse: 'collapse',
    width: '100%',

    '& thead': {
      '& tr': {
        backgroundColor: Colors.primaryColor,
        color: Colors.white,
        '& th': {
          fontSize: '1.2rem',
          padding: '1.5rem 0.5rem',
          fontWeight: 600,
          textTransform: 'uppercase',
          textAlign: 'center',
          borderBottom: `1px solid ${Colors.lightGray}`,
        },
      },
    },

    '& tbody': {
      '& tr': {
        borderLeft: `1px solid ${Colors.lightGray}`,
        borderRight: `1px solid ${Colors.lightGray}`,

        '&:hover': {
          backgroundColor: '#F3F3F3',
        },

        '&:not(:last-child)': {
          borderBottom: `1px solid ${Colors.lightGray}`,
        },

        '& td': {
          padding: '0.5rem 2rem',
          textAlign: 'center',
          fontSize: '1.2rem',

          '& svg': {
            verticalAlign: 'middle',
            marginRight: '0.5rem',
            marginBottom: '0.4rem',
          },
        },
      },
    },
  },

  rowItem: {
    backgroundColor: Colors.lightGray,
    border: 0,
    borderRadius: '0.8rem',
    outline: 'none',
    padding: '1rem',
    cursor: 'pointer',
    fontSize: '1rem',

    display: 'block',

    '& > div': {
      display: 'flex',
      flexDirection: 'column',
      gap: '0.25rem',
      alignItems: 'flex-start',
    },

    '&:hover': {
      backgroundColor: Colors.mediumLightGray,
    },

    '& svg': {
      margin: '0 !important',
    },

    '& > span': {
      display: 'block',
      marginBottom: '0.25rem',
      fontWeight: 600,
    },
  },

  document: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
  },

  flow: {
    display: 'flex',
    flexDirection: 'row',
    gap: '1rem',
    flexWrap: 'wrap',
  },

  column: {
    display: 'flex',
    gap: '1rem',
  },

  noResults: {
    fontSize: '1.2rem',
    padding: '2rem',
    fontWeight: 600,
    color: `${Colors.lightGray}`,
  },

  row: {
    display: 'flex',
  },

  center: {
    justifyContent: 'center',
  },

  deactivated: {
    color: `${Colors.lightGray}`,
  },

  modalRoot: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: '100%',
    height: '100%',
    gap: '1rem',
  },

  modalBody: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '1rem',
    width: '100%',
  },

  modalImage: {
    maxWidth: 'calc(33% - 1rem)',
  },
}))

export default styles
